'use client';

import { analytics } from 'lib/analytics/analytics';
import { ShippingBox } from 'assets/icons';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import {
  MiscRingCheckoutTypes,
  RingPriceData,
  AirRingColors,
} from 'content/products/ring';
import { useFormatPrice } from 'hooks/pricing/useFormattedPrice';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { DotSpinner, useModal } from '..';
import { useCartStore } from 'components/shared/Cart';
import { RingSelectionContext } from './RingSelectionContext';
import { sddCheckoutEta } from './DeliveryEtaBadge/useSddNddEligibility';
import styles from './BottomBarAlternate.module.css';

export const BottomBarAlternate = ({
  className,
  misc,
}: {
  className?: string;
  misc?: MiscRingCheckoutTypes;
}) => {
    const t = useTranslations('common');
    const RingSelectionClient = useContext(RingSelectionContext);
    const {
      size,
      shippingEstimate,
      sddNdd,
      checkout,
      color,
      isLoading,
      notServicable,
    } = RingSelectionClient;

    const store = useCartStore((s) => s.store);
    const ModalClient = useModal();
    const formatPriceWithComma = useFormatPrice();

    const handleCheckout = () => {
      openCheckoutInfo();
    };

    const openCheckoutInfo = () => {
      handleProceedClick();
      return;
    };

    const handleProceedClick = () => {
      if (isLoading) return;
      analytics.track('ring-air-checkout', {
        clicked: true,
      });
      checkout();
      ModalClient.hide();
    };

    const sctollToOrderSummary = () => {
      const ref = document.getElementById('order-summary-card');
      if (ref) ref.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    if (notServicable === true) return null;
    if (!store || !color) return null;

    const MidPriceSection = (
      <>
        <div className={styles.midPanel}>
          <p className={styles.totalPriceSingle}>
            <span
              className={
                misc === MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT
                  ? styles.striked
                  : ''
              }
            >
              {RingSelectionClient.currencySymbol}
              {formatPriceWithComma(
                RingPriceData[store as ShopifyStore][color as AirRingColors]
                  .price,
              )}
            </span>
            {misc === MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT ? (
              <span>{t('bottomBarAlternate.text.free')}</span>
            ) : null}
          </p>
        </div>

        <div className={styles.midPanelPhone} onClick={sctollToOrderSummary}>
          <div className={styles.subtitleTextBtn}>
            {t('bottomBarAlternate.content.total')}
          </div>
          <p className={styles.totalPriceSingle}>
            <span
              className={
                misc === MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT
                  ? styles.striked
                  : ''
              }
            >
              {RingSelectionClient.currencySymbol}
              {formatPriceWithComma(
                RingPriceData[store as ShopifyStore][color as AirRingColors]
                  .price,
              )}
            </span>
            {misc === MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT ? (
              <span>
                {RingSelectionClient.currencySymbol}
                {t('bottomBarAlternate.text.free')}
              </span>
            ) : null}
          </p>
        </div>
      </>
    );

    const checkoutEta = sddCheckoutEta(sddNdd.state);

    return (
      <div
        className={`${styles.root} u-grid${className ? ` ${className}` : ''}`}
        data-bottom-bar
      >
        <div className={styles.leftPanel}>
          {/* <p className="chat-specialist">
          {RingSelectionClient.price} --- {RingSelectionClient.effectivePrice}
        </p> */}
          {checkoutEta ? (
            <p className={styles.chatSpecialist}>
              <ShippingBox /> {checkoutEta}
            </p>
          ) : shippingEstimate ? (
            <p className={styles.chatSpecialist}>
              <ShippingBox /> {shippingEstimate}
            </p>
          ) : null}
        </div>

        {RingSelectionClient.size ? MidPriceSection : null}

        <div className={styles.rightPanel}>
          <button
            className={`${styles.blueBtn} blue-btn`}
            onClick={handleCheckout}
            disabled={!size || isLoading}
            aria-busy={isLoading}
          >
            {isLoading ? (
              <DotSpinner color="#000000" />
            ) : (
              <>
                {misc === MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT ? (
                  <>
                    {RingSelectionClient.size
                      ? t('bottomBarAlternate.button.continueCheckout')
                      : t('bottomBarAlternate.button.pleaseSelectColor')}
                  </>
                ) : (
                  ''
                )}
                {!misc ? (
                  <>
                    {RingSelectionClient.size
                      ? t('bottomBarAlternate.button.addCart')
                      : t('bottomBarAlternate.button.pleaseSelectColor')}
                  </>
                ) : null}
              </>
            )}
          </button>
        </div>
      </div>
    );
};
